<template>
  <b-row>
    <b-col md="3">
      <ClientInfoCard @refresh="refresh" />
    </b-col>

    <b-col md="9">
      <b-card>
        <div class="d-flex justify-content-end">
          <b-dropdown
            v-if="GET_USER_PERMISSIONS.includes('sales_management')"
            :text="$t('kanban.actions')"
            variant="success"
            right
          >
            <b-dropdown-item
              v-for="step in getCrmStepsList.results"
              :key="step.id"
              :variant="step.color"
              @click="changeSteps(step.id)"
            >
              <feather-icon
                :icon="step.icon"
                class="mr-50"
                size="20"
              />
              {{ step.title[$i18n.locale] }}
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <hr>

        <b-tabs fill>
          <b-tab :title="$t('kanban.events')">
            <b-row>
              <b-col md="6">
                <Comments
                  :content-type="getContentType"
                  :object-id="$route.params.id"
                />
              </b-col>
            </b-row>
          </b-tab>
          <!-- <b-tab title="Задачи">
            <ContractListTable :contracts="this.getContracts.results"/>
          </b-tab> -->
          <b-tab :title="$t('kanban.files')">
            <Files :content-type="getContentType" />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BTabs, BTab, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import ClientInfoCard from '../Clients/components/ClientInfoCard.vue'
import Files from '../Clients/components/Files.vue'
import Comments from '../Clients/components/Сomments.vue'
import contentType from '../../../utils/contentTypes'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTabs,
    BTab,
    BDropdown,
    BDropdownItem,
    ClientInfoCard,
    Files,
    Comments,
  },
  computed: {
    ...mapGetters('kanban', ['getLid', 'getCrmStepsList']),
    ...mapGetters('users', ['GET_USER_PERMISSIONS']),
    getContentType() {
      return contentType['sales_bpm/salesbpm']
    },
  },
  async mounted() {
    const response = await this.FETCH_ONE_LID(this.$route.params.id)
    this.FETCH_ONE_CLIENT(response.data.client.id)
    this.FETCH_CRM_STEPS()
  },
  methods: {
    ...mapActions('kanban', ['FETCH_ONE_LID', 'FETCH_CRM_STEPS', 'UPDATE_ONE_LID']),
    ...mapActions('clients', ['FETCH_ONE_CLIENT']),
    refresh() {
      this.FETCH_ONE_CLIENT(this.getLid.client.id)
    },
    changeSteps(id) {
      this.UPDATE_ONE_LID({
        id: this.getLid.id,
        data: {
          current_step: id,
        },
      })
    },
  },
}
</script>

<style>

</style>
